import React from "react"
import { Card, Typography } from "antd"
import { MediaPreview } from "ui/MediaPreview"
import WithEmptyStateWrapper from "ui/WithEmptyStateWrapper"
import { DSIcon } from "ui/Icon/DSIcon"
import PropTypes from "prop-types"
import styles from "./index.module.css"

const { Title } = Typography

/**
 * GallerySection component displays media gallery for equipment
 * @param {Array} media - Array of media items (photos/videos)
 * @param {Function} onMediaClick - Handler for media item click
 * @param {Function} t - Translation function
 */
const GallerySection = ({ media = [], onMediaClick, t }) => {
  return (
    <Card className={styles.galleryCard}>
      <Title level={4}>{t("equipment.details.gallery")}</Title>
      <WithEmptyStateWrapper
        name="media"
        hasItems={media.length > 0}
        fallbackTitle={t("equipment.details.no_media")}
        fallbackButtonText={t("equipment.details.upload_photos", { defaultValue: "Upload Photos" })}
        fallbackImageSrc={<DSIcon name="boat" width={80} height={80} />}
      >
        <div className={styles.gallery}>
          {media.map((mediaItem) => (
            <div key={mediaItem.id} className={styles.galleryItem}>
              <MediaPreview
                media={mediaItem}
                className={styles.galleryImage}
                lazyLoad={false}
                onClick={() => onMediaClick(mediaItem)}
              />
            </div>
          ))}
        </div>
      </WithEmptyStateWrapper>
    </Card>
  )
}

GallerySection.propTypes = {
  media: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      url: PropTypes.string,
      preview_url: PropTypes.string,
      type: PropTypes.string
    })
  ),
  onMediaClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

GallerySection.defaultProps = {
  media: []
}

export default GallerySection
